// Local overrides for project data coming from gitconnected.
// Keys must match project.name from the API.
const projectDetails = {
  'Novello': {
    highlights: [
      'Built the shift booking app for healthcare workers with Expo and MobX-State-Tree',
      'Implemented real-time updates with Socket.io and map views with React Native Maps',
      'Added document and image uploads, deep linking via Branch and fast local storage with MMKV'
    ],
    description:
      'Nursing agency platform for matching healthcare workers with NHS and private hospitals. The nursing shift solution empowers Novello Healthcare to outshine competitors, enabling lower fees through strategic digital implementation.',
    links: [
      { label: 'Website', url: 'https://novellohealthcare.com' },
      { label: 'Case study', url: 'https://apiko.com/portfolio/novello-healthcare-nursing-shift-app-development/' }
    ]
  },
  'Good Life Sorted': {
    highlights: [
      'Worked across the whole stack: React Native app, Next.js web and NestJS / Fastify backend',
      'Integrated Stripe payments, SendGrid emails and push notifications (OneSignal, Expo Notifications)',
      'Set up AWS infrastructure with Terraform; used device features — calendar, contacts, location, documents'
    ],
    roles: ['Full Stack Developer'],
    description:
      'Agetech marketplace for older adults and vetted helpers. Lets families hire hand-picked, trained and dependable helpers in their community to take care of older relatives — with household chores, cooking, shopping or just having a tea and a chat.',
    links: [
      { label: 'Website', url: 'https://goodlifesorted.com/' },
      { label: 'Case study', url: 'https://apiko.com/portfolio/goodlifesorted-age-tech-marketplace/' },
      { label: 'Clutch review', url: 'https://clutch.co/profile/apiko?page=1#review-1625951' }
    ]
  },
  'conexwest': {
    highlights: [
      'Built the production management mobile app in React Native with MobX-State-Tree',
      'Implemented photo capture, cropping and zoom for task reports',
      'Added Google & Apple sign-in, push notifications (OneSignal) and multi-language support'
    ],
    description:
      'Manufacturing production app for enterprise efficiency transformation. Web platform and SaaS solution to sell, rent, fabricate and modify shipping and storage containers — the operations management software cut task management for Conexwest from weeks down to minutes.',
    links: [
      { label: 'Website', url: 'https://conexyard.com/dashboard' },
      { label: 'Case study', url: 'https://apiko.com/portfolio/projectboardio-manufacturing-production-app/' },
      { label: 'Clutch review', url: 'https://clutch.co/profile/apiko#review-2027775' }
    ]
  },
  'Huddex': {
    highlights: [
      'Built both customer and courier flows with Expo and Apollo GraphQL',
      'Integrated Stripe payments and IBAN validation',
      'Added Google & Apple sign-in, Google Maps and push notifications via OneSignal'
    ],
    description:
      'Mobile app for two types of users: customers who need to ship packages quickly, and couriers — who can be anyone. Travelers earn extra money simply by taking a small package with them on their flight.',
    links: [{ label: 'Website', url: 'http://huddex.com' }]
  },
  'Multi': {
    highlights: [
      'Developed the currency exchange app in React Native with MobX-Keystone',
      'Integrated Firebase (Analytics, Firestore, Messaging), Branch deep linking and Smartlook analytics',
      'Built forms with React Hook Form and Formik + Yup, and map views with React Native Maps'
    ],
    description:
      'Fintech app for the top financial platform in Ukraine. Converts 150+ currencies hassle-free and helps banks and their customers tap into the benefits of digitalization.'
  },
  'Confetti': {
    highlights: [
      'Built the event host app with Expo, Apollo GraphQL and Native Base',
      'Implemented media upload and download (Expo Media Library, File System, RN Fetch Blob)',
      'Built forms with React Hook Form and Yup, with localization via i18next'
    ],
    description:
      'A digital invite to join exclusive weddings of your favorite celebrities and creators.',
    links: [{ label: 'Website', url: 'https://www.confetti.stream' }]
  },
  'InList': {
    highlights: [
      'Developed venue discovery and reservation flows in React Native with MobX-State-Tree',
      'Integrated push notifications (OneSignal), deep linking (Branch) and Firebase Analytics',
      'Built booking forms with Formik and Yup validation'
    ],
    description:
      'Members-only mobile app for booking upscale nightlife and special event reservations. Recommends the hottest venues nightly in cities like New York, Miami, Las Vegas, London, Paris, Ibiza and Dubai — a 24/7 concierge in the palm of your hand, backed by a worldwide network of top club owners and promoters.',
    url: 'https://apps.apple.com/us/app/inlist/id694967200',
    links: [{ label: 'Website', url: 'https://www.inlist.com/' }]
  },
  'The Fleet Club': {
    highlights: [
      "Built the members' booking app with Expo and Apollo GraphQL",
      'Implemented animated UI with Reanimated and Lottie, styled with Dripsy',
      'Added localization (i18next), in-app support chat (Intercom) and crash monitoring (Sentry)'
    ],
    description:
      'Private VIP flight management system and mobile app for club members to book flights.',
    links: [{ label: 'Website', url: 'https://fleetclubs.com' }]
  }
};

const DEFAULT_ROLES = ['React Native Developer'];

export const mergeProjectDetails = (projects = []) =>
  projects.map((project) => ({
    ...project,
    roles: DEFAULT_ROLES,
    ...(projectDetails[project.name] || {})
  }));

export default projectDetails;
